/**
 * Copyright (c) 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */

import * as React from 'react';
import { Redirect } from 'react-router-dom';

export const NotFound = () => {
  return <Redirect to={{ pathname: '/login' }} />;
};
